<template>
    <main id="import_actes" v-cloak>
        <HeaderTab :title="$t('global.import_actes')" :swiper_tabs="swiper_tabs" />

        <div id="content">
            <div class="row">
                <div class="col-12">
                    <div>
                        <router-view></router-view>
                    </div>
                </div>
            </div>
        </div>
    </main>
</template>

<script type="text/javascript">
    import Navigation from "@/mixins/Navigation.js";

    export default {
        name: "ImportActes",
        mixins: [Navigation],
        data () {
            return {
                swiper_tabs: [],
            }
        },

        mounted() {
            this.swiper_tabs = [
                {
                    id: 'import_performant_trot',
                    label: 'global.import_performant_trot',
                    active: true,
                    href: 'ImportPerformantTrot'
                },
            ]
        },

        components: {
            HeaderTab: () => import('@/components/HeaderTab'),
        }
    }
</script>
